import {
  CAMERA_DEFAULTS,
  WATER_DEFAULTS,
  type WaterState,
  type CameraState,
  type SkySceneMode,
} from './skyStore';

export interface CameraRig {
  id: string;
  sceneMode: SkySceneMode;
  scroll: boolean;
  traffic: boolean;
  defaults: CameraState;
  waterDefaults: WaterState;
}

export const SKY_RIG: CameraRig = {
  id: 'sky',
  sceneMode: 'sky',
  scroll: true,
  traffic: true,
  defaults: CAMERA_DEFAULTS,
  waterDefaults: WATER_DEFAULTS,
};

export const DENMARK_SWIMMING_RIG: CameraRig = {
  id: 'denmark swimming',
  sceneMode: 'water',
  scroll: false,
  traffic: false,
  defaults: {
    ...CAMERA_DEFAULTS,
    pitchTop: -19,
    pitchBottom: -19,
    heightTop: 10,
    heightBottom: 10,
    fovTop: 30,
    fovBottom: 30,
    sway: 0.12,
    swayBottom: 0.12,
    darkenOnScroll: 0.05,
  },
  waterDefaults: {
    ...WATER_DEFAULTS,
    speed: 1.55,
    rippleSize: 2.5,
    distortion: 5,
    roughness: 0.5,
    color: '#001e2f',
    sunlight: 1,
  },
};

export const cameraRigForPath = (pathname: string | null): CameraRig =>
  pathname?.startsWith('/denmark-swimming') ? DENMARK_SWIMMING_RIG : SKY_RIG;
